/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { TextMd } from './text.Md';
import { TextSettings } from './text.Settings';

export const TextGlobal = props => {
  const {
    itemId,
    textId,
    text,
    getTextHeight,
    displayType = 'hauteur dynamique',
    boardTabId,
    gridLayoutKey,
    canEdit = true,
  } = props;

  const isLabel = displayType === 'label';
  const isDynamicHeight = displayType === 'hauteur dynamique';

  const containerClasses = ['w-full'];
  if (isLabel) {
    containerClasses.push('h-full', 'flex', 'flex-col', 'items-center', 'justify-center', 'text-center');
  } else {
    containerClasses.push('flex', 'justify-center');
    if (!getTextHeight) {
      containerClasses.push('overflow-auto', 'h-full');
    }
  }

  const textStyle = isLabel
    ? { width: '100%', textAlign: 'center' }
    : { maxWidth: '700px' };

  return (
    <div className={containerClasses.join(' ')}>
      {canEdit && (
        <TextSettings
          itemId={itemId}
          textId={textId}
          text={text}
        />
      )}

      <TextMd
        getTextHeight={isDynamicHeight ? getTextHeight : null}
        boardTabId={boardTabId}
        gridLayoutKey={gridLayoutKey}
        itemId={itemId}
        textId={textId}
        str={text.text}
        style={textStyle}
      />
    </div>
  );
};
